import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-search',
  styleUrls: ['./search.component.scss'],
  templateUrl: './search.component.html'
})

export class SearchComponent {

  private key: string;

  public search: boolean;

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    this.key = event.key;
    if (this.key === 'Escape') {
      if (this.search = true) {
        this.search = false;
      }
    }
  }

  toggleSearch() {
    this.search = !this.search;
  }
}
